// @flow

import React from "react";
import { localize } from "redux-i18n";
import { SimpleGrid, WistiaPlayer, Text, View } from "@components";

type Props = PropsFromLocalize;

const HelpPanelSecurity = (props: Props) => {
  return (
    <View>
      <View gap={4}>
        <Text>{props.t("SECURITY_INTRODUCTION")}</Text>
        <Text type="h6" className="font-weight-bold mb-1">
          {props.t("TUTORIAL_SECURITY_SETTINGS")}
        </Text>
      </View>
      <WistiaPlayer
        videoId={WistiaPlayer.videos.SECURITY_SETTINGS}
        title={props.t("SECURITY_INSTRUCTIONS")}
      />
    </View>
  );
};

export default localize()(HelpPanelSecurity);
